import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalGenericoComponent } from './modal-generico.component';
import { DirectivesModule } from '../../../core/directives/directives.module';

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule
  ],
  declarations: [ModalGenericoComponent],
  exports: [ModalGenericoComponent],
})
export class ModalGenericoModule { }
